/* global Micropayment gtag */
const igDonationContainer = document.querySelector('.donation')


// TODO: validation type and params as input attributes so there is no need for redundant js
if (igDonationContainer) {
    // amount page
    const amountPage = {}
    amountPage.paymentInformationContainer = igDonationContainer.querySelector('.payment-information')
    amountPage.directDebitContainer = igDonationContainer.querySelector('.payment-information .direct-debit')
    amountPage.payPalInput = igDonationContainer.querySelector('[data-payment-method=paypal]') || null
    amountPage.creditCardInput = igDonationContainer.querySelector('[data-payment-method=credit_card]')
    amountPage.amountContainer = igDonationContainer.querySelector('.amount-suggestions')
    amountPage.allAmountInputs = igDonationContainer.querySelectorAll('.amount-suggestions input[name=amount]')
    amountPage.customAmountInput = igDonationContainer.querySelector('.amount-suggestions input[name=custom-amount]')
    amountPage.allRhythmInputs = igDonationContainer.querySelectorAll('.rhythms input[name=rhythm]')
    amountPage.donateWithoutDataCheckbox = igDonationContainer.querySelector('[name=donate_without_data]')
    amountPage.accountHolderField = igDonationContainer.querySelector('[name=account_holder]')
    amountPage.ibanField = igDonationContainer.querySelector('[name=iban]')
    amountPage.bicField = igDonationContainer.querySelector('[name=bic]')
    amountPage.allPaymentMethods = igDonationContainer.querySelectorAll('.payment-methods [name=payment_methods]')
    amountPage.donorNameInput = window.pages[0].querySelector('[name=donor_name]')
    amountPage.graveyardInput = window.pages[0].querySelector('[name=graveyard_name]')
    amountPage.runContainer = igDonationContainer.querySelector('.run-suggestions')
    amountPage.allDistanceInputs = igDonationContainer.querySelectorAll('.run-suggestions input[name=distance]')
    amountPage.customDistanceeInput = igDonationContainer.querySelector('.run-suggestions input[name=custom-distance]')

    // flowerdonation details
    amountPage.flowerDonationRecordInput = igDonationContainer.querySelector('input#flowerdonationRecord');
    amountPage.flowerDonationFlowersCountInput = igDonationContainer.querySelector('input#flowerdonationFlowersCount');

    // donor certificate
    amountPage.certificateEnableCheckbox = igDonationContainer.querySelector('input#donation_certificate_enable')
    amountPage.certificateFromInput = igDonationContainer.querySelector('input#donation_certificate_from')
    amountPage.certificateToInput = igDonationContainer.querySelector('input#donation_certificate_to')
    amountPage.certificateEmailInput = igDonationContainer.querySelector('input#donation_certificate_email')
    amountPage.certificateMessageTextarea = igDonationContainer.querySelector('textarea#donation_certificate_message')
    amountPage.certificateVbEmailInput = igDonationContainer.querySelector('input#donation_certificate_vb_email')
    amountPage.certificatePdfTemplateInput = igDonationContainer.querySelector('input#donation_certificate_pdf_template')

    // micropayment
    amountPage.micropaymentTag = document.createElement('script')
    amountPage.micropaymentTag.setAttribute('project', igDonationContainer.getAttribute('data-micropayment-project-id'))
    amountPage.micropaymentTag.setAttribute('form_submit', 'off')
    amountPage.micropaymentTag.setAttribute('prefix', 'micropayment_')
    amountPage.micropaymentTag.setAttribute('tokenize', '1')
    //amountPage.micropaymentTag.setAttribute('testmode', '1')
    amountPage.micropaymentTag.src = 'https://sipg.micropayment.de/public/bridge/v1/mp.js'

    // personal data page
    const personalDataPage = {}
    personalDataPage.allInputs = window.pages[1].querySelectorAll('input, textarea')
    personalDataPage.countrySelect = window.pages[1].querySelector('select[name=country]')
    personalDataPage.emailInput = window.pages[1].querySelector('#input_email');

    // confirmation page
    const confirmationPage = {}
    confirmationPage.donationAmountInput = window.pages[2].querySelector('[name=donation_amount]')
    confirmationPage.donationRhythmInput = window.pages[2].querySelector('[name=donation_rhythm]')
    confirmationPage.allInputs = window.pages[2].querySelectorAll('input, textarea')
    confirmationPage.yourDataHeadline = window.pages[2].querySelector('#your-data-headline')

    // backend endpoints/const/urls
    const paypalSessionCreationUrl = igDonationContainer.getAttribute('data-paypal-endpoint')
    const fullfillDonationUrl = igDonationContainer.getAttribute('data-fullfill-donation-endpoint')
    const micropaymentTokenUrl = igDonationContainer.getAttribute('data-micropayment-token-entpoint')
    let thankYouUrl = igDonationContainer.getAttribute('data-thankyou-page')
    const donationboxPid = igDonationContainer.getAttribute('data-donationbox-pid')

    // constants
    const minimumDonationAmount = parseInt(igDonationContainer.getAttribute('data-minimum-amount'))
    const loadingHTML = '<div class="spinner-border btn-red" role="status"></div>'

    let micropaymentResponse

    // Event Listener to prefill the donors email input with the value
    // of the email input in the certificate section if this is set
    // set the email input in the personal data section to valid
    // if the user changes the input again in personal data - validation is active again
    if (amountPage.certificateEmailInput) {
        amountPage.certificateEmailInput.addEventListener('change', function() {
            personalDataPage.emailInput.value = this.value;
            personalDataPage.emailInput.classList.add('is-valid');
        })
    }

    // next button logic
    window.nextButton.addEventListener('click', async () => {
        let pageIsValid = true
        let errorElement = null

        // check if all required fields have the class `is-valid`,
        // otherwise set `pageIsValid` to false
        window.pages[window.currentPage].querySelectorAll('.required, .optional').forEach(
            element => {
                if (!element.classList.contains('is-valid')) {
                    if (element.classList.contains('optional')) {
                        if (element.value.length) {
                            pageIsValid = false
                            window.setFieldInvalid(element)
                            if (!errorElement) errorElement = element
                        }
                    } else {
                        pageIsValid = false
                        window.setFieldInvalid(element)
                        if (!errorElement) errorElement = element
                    }
                }
            }
        )

        // validate certificate input fields if user wants a donation certificate
        if(amountPage.certificateEnableCheckbox && amountPage.certificateEnableCheckbox.checked) {
            window.pages[window.currentPage].querySelectorAll('.certificate-required').forEach(
                certificateField => {
                    if (certificateField.getAttribute('type') === 'email') {
                        if (!window.validateEmail(certificateField.value)) {
                            pageIsValid = false
                            certificateField.classList.add('validation-error')
                            window.setFieldInvalid(certificateField)
                            if (!errorElement) errorElement = certificateField
                        } else {
                            window.setFieldValid(certificateField)
                        }
                    }
                    if (certificateField.getAttribute('type') === 'text') {
                        if (!window.validateStringLength(certificateField.value, 1, 25)) {
                            pageIsValid = false
                            certificateField.classList.add('validation-error')
                            window.setFieldInvalid(certificateField)
                            if (!errorElement) errorElement = certificateField
                        } else {
                            window.setFieldValid(certificateField)
                        }
                    }
                    if (certificateField.tagName === 'TEXTAREA') {
                        if (!window.validateStringLength(certificateField.value, 0, 440)) {
                            pageIsValid = false
                            certificateField.classList.add('validation-error')
                            window.setFieldInvalid(certificateField)
                            if (!errorElement) errorElement = certificateField
                        }
                        else {
                            window.setFieldValid(certificateField)
                        }
                    }
                }
            )
        }

        if (window.currentPage === 0) {
            if ( amountPage.creditCardInput && amountPage.creditCardInput.checked ) {
                Micropayment.makeToken()

                await new Promise((resolve, reject) => {
                    Micropayment.addEvent('error', response => {
                        micropaymentResponse = response
                        reject(response)
                    })

                    Micropayment.addEvent('success', response => {
                        micropaymentResponse = response
                        resolve(response)
                    })
                }).then(response => {

                }).catch(response => {
                    errorElement = amountPage.creditCardInput
                    pageIsValid = false
                })
            }
        }

        if (pageIsValid) {
            const position = window.getPos(window.pageIndicatorContainer)[1]
            window.scrollToSmoothly(position - 100, 1)

            if (window.currentPage === 0) {
                // redirect user directly to paypal if paypal is selected as payment method.
                if (amountPage.payPalInput && amountPage.payPalInput.checked) {
                    window.nextButton.innerHTML = loadingHTML
                    let certifcateData = null;
                    if(amountPage.certificateEnableCheckbox && amountPage.certificateEnableCheckbox.checked) {
                        certifcateData = {
                            from: amountPage.certificateFromInput.value,
                            to: amountPage.certificateToInput.value,
                            email: amountPage.certificateEmailInput.value,
                            message: amountPage.certificateMessageTextarea.value,
                            vbEmail: amountPage.certificateVbEmailInput.value,
                            pdfTemplate: amountPage.certificatePdfTemplateInput.value
                        }
                    }

                    window.post(
                        response => {
                            try {
                                var responseObj = JSON.parse(response);
                                if (responseObj.checkoutUrl) {
                                    window.location = responseObj.checkoutUrl;
                                } else {
                                    console.error("CheckoutUrl not found in reponse: ", responseObj);
                                }
                            } catch (e) {
                                console.error("Error parsing response: ", response, "Error: ", e);
                            }
                        },
                        paypalSessionCreationUrl,
                        {
                            amount: window.getDonationAmount(),
                            distance: window.getDonationDistance(),
                            campaign: igDonationContainer.getAttribute('data-campaign'),
                            donor_name: amountPage?.donorNameInput?.value,
                            donationbox_pid: donationboxPid,
                            graveyard_name: amountPage?.graveyardInput?.value,
                            certificateData: certifcateData
                        }
                    )
                    return
                }

                // hide page with personal data if user does not want a donation receipt.
                if (amountPage.donateWithoutDataCheckbox.checked) {
                    window.pages[1].classList.add('disabled')
                    window.pageIndicators[1].classList.add('disabled')
                    confirmationPage.yourDataHeadline.classList.add('d-none')
                } else {
                    window.pages[1].classList.remove('disabled')
                    window.pageIndicators[1].classList.remove('disabled')
                    confirmationPage.yourDataHeadline.classList.remove('d-none')
                }

                // fill fields on the confirmation page with actual data.
                confirmationPage.donationAmountInput.value = window.getDonationAmount() + ' EURO'
                confirmationPage.donationRhythmInput.value = window.getDonationRhythm(true)
            }

            if (window.currentPage === 1) {
                // fill fields on the confirmation page with actual data.
                personalDataPage.allInputs.forEach(input => {
                    if (input.value.length) {
                        const confirmationElement = window.pages[2].querySelector(
                            '[name=' + input.name + ']'
                        )

                        if (confirmationElement) {
                            confirmationElement.value = input.value
                            confirmationElement.parentElement.classList.remove('d-none')
                        }
                    }
                })
            }

            if (window.currentPage === 2) {
                const donationData = {
                    amount: window.getDonationAmount(),
                    distance: window.getDonationDistance(),
                    donationbox_pid: donationboxPid,
                    rhythm: window.getDonationRhythm(false),
                    project_id: igDonationContainer.getAttribute('data-project-id'),
                    campaign: igDonationContainer.getAttribute('data-campaign'),
                    country: personalDataPage.countrySelect.value,
                    graveyard_name: amountPage?.graveyardInput?.value,
                    starIdentifier: igDonationContainer.getAttribute('data-staridentifier') || null,
                    starId: igDonationContainer.getAttribute('data-starid') || null,
                }

                if (amountPage.donorNameInput) {
                    donationData.donor_name = amountPage.donorNameInput.value
                }

                if (amountPage.directDebitContainer.classList.contains('enabled')) {
                    donationData.sepa_account_holder = amountPage.accountHolderField.value
                    donationData.sepa_iban = amountPage.ibanField.value
                    donationData.sepa_bic = amountPage.bicField.value
                }

                personalDataPage.allInputs.forEach(input => {
                    if (input.getAttribute('type') === 'checkbox') {
                        donationData[input.name] = input.checked
                    } else {
                        if (input.value) {
                            donationData[input.name] = input.value
                        }
                    }
                })

                if (amountPage.flowerDonationRecordInput) {
                    donationData.flowerDonation = {
                        flowerDonationRecord: amountPage.flowerDonationRecordInput.value,
                        flowerDonationFlowersCount: amountPage.flowerDonationFlowersCountInput.value
                    }
                }

                if (amountPage.certificateEnableCheckbox && amountPage.certificateEnableCheckbox.checked) {
                    // add certificate data as own object to donationData
                    donationData.certificate = {
                        from: amountPage.certificateFromInput.value,
                        to: amountPage.certificateToInput.value,
                        email: amountPage.certificateEmailInput.value,
                        message: amountPage.certificateMessageTextarea.value,
                        vbEmail: amountPage.certificateVbEmailInput.value,
                        pdfTemplate: amountPage.certificatePdfTemplateInput.value
                    }
                }

                if (micropaymentResponse) {
                    window.nextButton.innerHTML = loadingHTML

                    window.post(
                        response => {
                            const object = JSON.parse(response)
                            donationData.sessionId = object.session

                            Micropayment.session(
                                object.session, window.location.href
                            )

                            setTimeout(() => {
                                window.post(
                                    response => {
                                        response = JSON.parse(response)

                                        if (response.valid === true) {
                                            try {
                                                gtag('event', 'conversion', {
                                                    send_to: 'AW-930657739/Vz0ZCJ2W73kQy-viuwM',
                                                    transaction_id: ''
                                                })
                                            } catch (e) {
                                            }

                                            setTimeout(() => {
                                                Micropayment.process()
                                            }, 1500)
                                        }
                                    },
                                    fullfillDonationUrl,
                                    donationData
                                )
                            }, 1000)
                        },
                        micropaymentTokenUrl,
                        {
                            token: micropaymentResponse.token,
                            amount: window.getDonationAmount(true),
                            holder: micropaymentResponse.fields.holder.val
                        }
                    );

                    return
                }

                window.nextButton.innerHTML = loadingHTML
                window.post(
                    response => {
                        response = JSON.parse(response)

                        if (response.valid === true) {
                            try {
                                gtag('event', 'conversion', {
                                    send_to: 'AW-930657739/Vz0ZCJ2W73kQy-viuwM',
                                    transaction_id: ''
                                })
                            } catch (e) {
                            }
                            let donationType = 'credit_card';
                            for(const key in donationData) {
                                if(key.startsWith('sepa_')) {
                                    donationType = 'sepa';
                                }
                            }
                            if(thankYouUrl.includes('?')) {
                                thankYouUrl = thankYouUrl + '&donationType=' + donationType;
                            } else {
                                thankYouUrl = thankYouUrl + '?donationType=' + donationType;
                            }

                            setTimeout(() => {
                                window.location = thankYouUrl
                            }, 2000)
                        }
                    },
                    fullfillDonationUrl,
                    donationData
                )

                return
            }

            // hide elements without content on the confirmation page.
            confirmationPage.allInputs.forEach(input => {
                if (!input.value) input.parentElement.classList.add('d-none')
            })

            window.goToStep(window.currentPage + 1)
        } else {
            const position = window.getPos(errorElement)[1]
            window.scrollToSmoothly(position - 100, 1)
        }
    })

    // back button logic
    window.backButton.addEventListener('click', () => {
        window.goToStep(window.currentPage - 1)

        const position = window.getPos(window.pageIndicatorContainer)[1]
        window.scrollToSmoothly(position - 100, 1)
    })

    /*******************************************************
     * PAGE 0                                              *
     *******************************************************/

    // amount validation/logic
    amountPage.allAmountInputs.forEach(element => {
        element.addEventListener('change', event => {
            amountPage.customAmountInput.value = ''

            window.setFieldValid(
                amountPage.amountContainer
            )
        })
    })

    amountPage.customAmountInput.addEventListener('change', () => {
        amountPage.allAmountInputs.forEach(element => {
            element.checked = false
        })
        if (parseInt(amountPage.customAmountInput.value) >= minimumDonationAmount) {
            window.setFieldValid(
                amountPage.amountContainer
            )
        } else {
            window.setFieldInvalid(
                amountPage.amountContainer
            )
        }
    })

    // distance validation/logic
    if (amountPage.allDistanceInputs.length == 1) {
        amountPage.allDistanceInputs.forEach(element => {
            element.addEventListener('change', event => {
                amountPage.customDistanceeInput.value = ''

                window.setFieldValid(
                    amountPage.runContainer
                )
            })
        })

        amountPage.customDistanceeInput.addEventListener('change', () => {
            amountPage.allDistanceInputs.forEach(element => {
                element.checked = false
            })

            window.setFieldInvalid(
                amountPage.runContainer
            )
        })
    }

    // rhythm validation/logic
    amountPage.allRhythmInputs.forEach(input => {
        input.addEventListener('change', event => {
            const rhythmID = event.target.getAttribute('data-rhythm-key')

            // reset states/appearance of payment types buttons
            try {
                Micropayment.reset()
            } catch (e) {
            }
            const enabledPaymentMethod = amountPage.paymentInformationContainer.querySelector('div.enabled')
            if (enabledPaymentMethod) enabledPaymentMethod.classList.remove('enabled')
            amountPage.donateWithoutDataCheckbox.parentElement.classList.remove('d-none')
            window.nextButton.innerText = window.nextButton.getAttribute('data-default')
            amountPage.accountHolderField ? amountPage.accountHolderField.classList.remove('required', 'validation-error') : null
            amountPage.ibanField ? amountPage.ibanField.classList.remove('required', 'validation-error') : null
            amountPage.bicField ? amountPage.bicField.classList.remove('required', 'validation-error') : null

            switch (rhythmID) {
                // One time donation
                case 'E':
                    window.definePossiblePaymentMethods({
                        sepa_direct_debit: true,
                        credit_card: true,
                        paypal: true
                    })
                    break
                default:
                    window.definePossiblePaymentMethods({
                        sepa_direct_debit: true
                    })
                    break
            }

            window.setFieldValid(
                event.target.parentElement.parentElement
            )
        })
    })

    // payment method validation/logic
    amountPage.allPaymentMethods.forEach(element => {
        element.addEventListener('change', event => {
            window.setFieldValid(event.target.parentElement.parentElement)

            // reset states/appearance of payment types buttons
            try {
                Micropayment.reset()
            } catch (e) {
            }
            const enabledPaymentMethod = amountPage.paymentInformationContainer.querySelector('div.enabled')
            if (enabledPaymentMethod) enabledPaymentMethod.classList.remove('enabled')
            amountPage.donateWithoutDataCheckbox.parentElement.classList.remove('d-none')
            window.nextButton.innerText = window.nextButton.getAttribute('data-default')
            amountPage.accountHolderField ? amountPage.accountHolderField.classList.remove('required', 'validation-error') : null
            amountPage.ibanField ? amountPage.ibanField.classList.remove('required', 'validation-error') : null
            amountPage.bicField ? amountPage.bicField.classList.remove('required', 'validation-error') : null

            switch (event.target.getAttribute('data-payment-method')) {
                case 'sepa_direct_debit':
                    amountPage.paymentInformationContainer.querySelector(
                        '.direct-debit'
                    ).classList.add('enabled')

                    amountPage.accountHolderField.classList.add('required')
                    amountPage.ibanField.classList.add('required')

                    amountPage.accountHolderField.addEventListener('keyup', event => {
                        window.waitUntilUserHasFinishedTypingAndValidateField(
                            event.target,
                            {
                                type: 'text',
                                arguments: '1-100'
                            }
                        )
                    })

                    amountPage.ibanField.addEventListener('keyup', event => {
                        if (event.target.value.substring(0, 2).toUpperCase() === 'DE') {
                            amountPage.bicField.parentElement.querySelector('label').classList.remove('required-indicator')
                            amountPage.bicField.classList.remove('validation-error')
                            amountPage.bicField.classList.remove('required')
                        } else {
                            amountPage.bicField.parentElement.querySelector('label').classList.add('required-indicator')
                            amountPage.bicField.classList.add('required')
                        }

                        window.waitUntilUserHasFinishedTypingAndValidateField(
                            event.target,
                            {
                                type: 'iban'
                            }
                        )
                    })

                    amountPage.bicField.addEventListener('keyup', event => {
                        window.waitUntilUserHasFinishedTypingAndValidateField(
                            event.target,
                            {
                                type: 'bic'
                            }
                        )
                    })
                    break
                case 'credit_card':
                    // add micropayment script
                    document.head.appendChild(amountPage.micropaymentTag)

                    amountPage.micropaymentTag.onload = () => {
                        Micropayment.init()

                        Micropayment.addEvent('ready', () => {
                            Micropayment.style('border', '1px solid #C1C1C1')
                            Micropayment.style('border-radius', '3px')
                            Micropayment.style('background-color', '#ffffff')
                            Micropayment.style('margin-bottom', '40px')
                            Micropayment.style('width', 'calc(100% - 22px)')
                            Micropayment.style('padding', '10px')
                            Micropayment.style('font-size', '20px')
                        })
                    }

                    amountPage.paymentInformationContainer.querySelector(
                        '.credit-card'
                    ).classList.add('enabled')
                    break
                case 'paypal':
                    amountPage.donateWithoutDataCheckbox.parentElement.classList.add('d-none')
                    window.nextButton.innerText = 'Weiter zu PayPal'
                    break
            }
        })
    })

    // dataprotection validation
    igDonationContainer.querySelector('[name=data_protection_agreement]').addEventListener('change', event => {
        if (event.target.checked) {
            window.setFieldValid(
                event.target.parentElement
            )
        } else {
            window.setFieldInvalid(
                event.target.parentElement
            )
        }
    })

    /*******************************************************
     * PAGE 1                                              *
     *******************************************************/

    // TODO: func die den eventlistener drin hat, sollte selector & parameter übergeben
    // TODO: const addValidtion = () => {}

    // first name
    igDonationContainer.querySelector('[name=first_name]').addEventListener('change', event => {
        window.waitUntilUserHasFinishedTypingAndValidateField(
            event.target,
            {
                type: 'text',
                arguments: '2-100'
            }
        )
    })

    // last name
    igDonationContainer.querySelector('[name=last_name]').addEventListener(
        'change',
        event => window.waitUntilUserHasFinishedTypingAndValidateField(
            event.target,
            {
                type: 'text',
                arguments: '2-100'
            }
        )
    )

    // street
    igDonationContainer.querySelector('[name=address]').addEventListener(
        'change',
        event => window.waitUntilUserHasFinishedTypingAndValidateField(
            event.target,
            {
                type: 'text',
                arguments: '5-100'
            }
        )
    )

    // postcode
    igDonationContainer.querySelector('[name=postcode]').addEventListener(
        'change',
        event => window.waitUntilUserHasFinishedTypingAndValidateField(
            event.target,
            {
                type: 'text',
                arguments: '1-100'
            }
        )
    )

    // city
    igDonationContainer.querySelector('[name=city]').addEventListener(
        'change',
        event => window.waitUntilUserHasFinishedTypingAndValidateField(
            event.target,
            {
                type: 'text',
                arguments: '3-100'
            }
        )
    )

    // phone number
    igDonationContainer.querySelector('[name=phone].optional').addEventListener(
        'change',
        event => {
            if (event.target.value.length) {
                window.waitUntilUserHasFinishedTypingAndValidateField(
                    event.target,
                    {
                        type: 'phone-number'
                    }
                )
            } else {
                window.setFieldValid(event.target)
            }
        }
    )

    // fax
    igDonationContainer.querySelector('[name=fax].optional').addEventListener(
        'change',
        event => {
            if (event.target.value.length) {
                window.waitUntilUserHasFinishedTypingAndValidateField(
                    event.target,
                    {
                        type: 'phone-number'
                    }
                )
            } else {
                window.setFieldValid(event.target)
            }
        }
    )

    // email
    igDonationContainer.querySelector('[name=email]').addEventListener(
        'change',
        event => window.waitUntilUserHasFinishedTypingAndValidateField(
            event.target,
            {
                type: 'email'
            }
        )
    )

    // donor name
    if (amountPage.donorNameInput) {
        amountPage.donorNameInput.addEventListener(
            'change',
            event => window.waitUntilUserHasFinishedTypingAndValidateField(
                event.target,
                {
                    type: 'text',
                    arguments: '3-100'
                }
            )
        )
    }

    // custom message
    igDonationContainer.querySelector('[name=custom_message].optional').addEventListener(
        'change',
        event => {
            if (event.target.value.length) {
                window.waitUntilUserHasFinishedTypingAndValidateField(
                    event.target,
                    {
                        type: 'text',
                        arguments: '1-500'
                    }
                )
            } else {
                window.setFieldValid(event.target)
            }
        }
    )
}
